import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Menu', path: '/menu' },
  { label: 'Gallery', path: '/gallery' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? 'py-2'
            : 'bg-transparent py-5'
        }`}
        style={scrolled ? { background: 'linear-gradient(135deg, #1E0D05 0%, #2A1A0E 100%)', boxShadow: '0 2px 20px rgba(0,0,0,0.4)' } : {}}
      >
        {/* Mural top strip when scrolled */}
        {scrolled && (
          <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-saffron via-turmeric via-coral to-teal"></div>
        )}

        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          {/* Logo + Brand Name */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer group">
            <img
              src="https://public.readdy.ai/ai/img_res/19b809d9-7658-45a2-b8c9-63ddfa78d633.png"
              alt="Chaska Indian Kitchen"
              className="h-11 w-auto object-contain"
            />
            <div className={`transition-all duration-300 ${scrolled ? 'opacity-100' : 'opacity-0 -translate-x-2 pointer-events-none'}`}>
              <p className="font-serif text-white text-base font-bold leading-tight tracking-wide uppercase">CHASKA</p>
              <p className="font-sans text-saffron text-[10px] tracking-[0.2em] uppercase">INDIAN KITCHEN</p>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-sans font-medium text-sm tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap relative group ${
                  scrolled ? 'text-white/80 hover:text-saffron' : 'text-white/90 hover:text-saffron'
                } ${location.pathname === link.path ? 'text-saffron' : ''}`}
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-saffron transition-all duration-300 group-hover:w-full rounded-full"></span>
              </Link>
            ))}
          </div>

          {/* Right side buttons */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href="tel:+18645550123"
              className={`font-sans text-sm transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 ${
                scrolled ? 'text-white/75 hover:text-saffron' : 'text-white/85 hover:text-saffron'
              }`}
            >
              <i className="ri-phone-line text-saffron"></i>
              (864) 555-0123
            </a>
            <a
              href="tel:+18645550123"
              className="bg-saffron text-white font-sans font-semibold text-sm px-5 py-2.5 rounded-full hover:bg-coral transition-colors duration-200 cursor-pointer whitespace-nowrap flex items-center gap-1.5"
              style={{ boxShadow: '0 2px 12px rgba(255,107,53,0.35)' }}
            >
              <i className="ri-calendar-2-line text-xs"></i>
              Reserve
            </a>
          </div>

          {/* Hamburger */}
          <button
            className={`md:hidden p-2 cursor-pointer ${scrolled ? 'text-white' : 'text-white'}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div
            className="md:hidden border-t border-saffron/20 px-6 py-5 flex flex-col gap-4"
            style={{ background: 'linear-gradient(135deg, #1E0D05 0%, #2A1A0E 100%)' }}
          >
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-sans font-medium text-base cursor-pointer hover:text-saffron transition-colors ${
                  location.pathname === link.path ? 'text-saffron' : 'text-white/80'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:+18645550123"
              className="bg-saffron text-white font-sans font-semibold text-sm px-5 py-3 rounded-full text-center cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line"></i>
              Call to Reserve
            </a>
          </div>
        )}
      </nav>
    </>
  );
}
